import React, { useEffect } from "react";
import "../css/style.css";

function ProjectIntro() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = document.querySelectorAll(".fade-up");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="project-intro-section">
      <div className="container text-center">
        <p className="project-intro-text fade-up">
          <strong>Delivering Excellence Through Every Project</strong> 

          
        Our projects reflect NeatNest’s strong commitment to quality, reliability, and customer satisfaction. We have successfully completed a wide range of residential cleaning projects, including full home cleaning, deep kitchen cleaning, bathroom sanitation, and routine maintenance services. Each project is carefully planned and executed by trained cleaning professionals using safe, eco-friendly products and advanced cleaning techniques. We focus on removing dust, allergens, grease, and bacteria to create healthier living spaces. Attention to detail, timely service, and consistent quality are at the core of every project we undertake. Through our work, we continue to build long-lasting trust and deliver homes that feel fresh, clean, and welcoming.
    </p>
      </div>
    </section>
  );
}

export default ProjectIntro;
